import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

export default function Terminos() {
  return (
    <div className="min-h-screen font-body">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-mono text-muted-foreground hover:text-neon-cyan uppercase tracking-widest mb-8"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Volver al sitio
        </Link>

        <header className="mb-10 pb-8 border-b border-white/10">
          <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.3em] text-neon-cyan mb-3">
            <FileText className="w-3.5 h-3.5" />
            DOCUMENTO LEGAL
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-tight mb-3">
            Términos y Condiciones de Uso
          </h1>
          <p className="text-muted-foreground text-sm">
            Marketing de Inteligencia Artificial S. de R.L. de C.V. · FameWar / VibeWar
          </p>
        </header>

        <section className="space-y-8 text-white/85 leading-relaxed">
          <div>
            <div className="text-[11px] font-mono uppercase tracking-widest text-neon-cyan mb-2">
              PARTES DEL CONTRATO
            </div>
            <p>
              El presente contrato de Términos y Condiciones de Uso (en adelante "TCU") se celebra
              entre <strong>Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong>, con
              domicilio en Av. Américas 1545, pisos 20, 21, 22 y 23, Colonia Providencia,
              Guadalajara, Jalisco, México (en adelante "LA PLATAFORMA"), representada legalmente
              por <strong>C. RICARDO ZERMEÑO MEJÍA</strong> en su carácter de apoderado legal;
              y toda persona física o moral que acceda, registre o utilice cualquiera de los
              servicios ofrecidos en el sitio (en adelante "EL USUARIO").
            </p>
            <p className="mt-3">
              El uso de la plataforma implica la aceptación total, expresa e irrevocable del
              presente contrato.
            </p>
          </div>

          <Clause number="1" title="Mecánica del Incentivo">
            El 50% del pozo acumulado visible en pantalla se otorgará exclusivamente al usuario que
            ocupe de forma legítima la posición número #1 en la tabla de clasificación al momento
            exacto en que el contador llegue a cero (00:00:00). El 50% restante corresponde a la
            comisión operativa de la plataforma.
          </Clause>

          <Clause number="2" title="Regla de Extensión de Tiempo (Anti-Sniping)">
            Cualquier puja recibida dentro de los últimos dos (2) minutos previos al cierre
            extenderá automáticamente el temporizador por sesenta (60) segundos adicionales.
            Esto se repetirá de forma indefinida hasta que no se registren más pujas dentro del
            margen de cierre. La hora final es dictada exclusivamente por el servidor central
            de la plataforma.
          </Clause>

          <Clause number="3" title="Procesamiento de Premios">
            El ganador recibirá el pago en la cuenta o monedero especificado en su registro en un
            plazo máximo de cuarenta y ocho (48) horas hábiles tras la verificación de la
            transacción. Es responsabilidad única del usuario ingresar correctamente sus datos
            de cobro. LA PLATAFORMA no se hace responsable por transferencias fallidas debido
            a datos erróneos, cuentas inactivas o restricciones bancarias de terceros.
          </Clause>

          <Clause number="4" title="Política de No Reembolso">
            Todas las pujas y pagos realizados dentro de la plataforma son{" "}
            <strong>definitivos, absolutos y no reembolsables</strong> bajo ninguna circunstancia,
            ya que el espacio publicitario y de visibilidad se procesa e incrementa en tiempo
            real. La compra representa un servicio digital ejecutado instantáneamente.
          </Clause>

          <Clause number="5" title="Contenido Permitido">
            LA PLATAFORMA se reserva el derecho de eliminar, banear y confiscar los fondos de
            cualquier perfil que promueva contenido ilegal, discursos de odio, estafas (scams),
            fraude o material explícito no autorizado. Dichos usuarios no tendrán derecho a
            reclamación ni devolución del dinero aportado, sin necesidad de aviso previo.
          </Clause>

          <Clause number="6" title="Cuentas y Registro">
            El usuario es responsable de la veracidad de la información proporcionada durante el
            registro (celular, correo electrónico, wallet de cobro). Cualquier suplantación de
            identidad, uso de datos ajenos o registro fraudulento facultará a LA PLATAFORMA para
            suspender la cuenta y retener los fondos vinculados.
          </Clause>

          <Clause number="7" title="Programa Cazador Viral (10%)">
            El 10% del pozo se destina al programa de viralización. El cazador que acumule más
            puntos válidos al cierre recibirá dicho porcentaje. Los clics se validan por dirección
            IP única por día; se anulan automáticamente los generados por bots o software
            automatizado.
          </Clause>

          <Clause number="8" title="Impuestos y Retenciones">
            El usuario reconoce que cualquier premio recibido puede estar sujeto a las
            obligaciones fiscales del país en que resida. La declaración y pago de dichos
            impuestos corresponde exclusivamente al beneficiario.
          </Clause>

          <Clause number="9" title="Limitación de Responsabilidad">
            LA PLATAFORMA no será responsable por interrupciones del servicio derivadas de causas
            de fuerza mayor, ataques cibernéticos, fallas del proveedor de pagos o del proveedor
            de hosting. En cualquier caso, la responsabilidad total de LA PLATAFORMA se limita al
            monto pagado por el usuario en las últimas 72 horas.
          </Clause>

          <Clause number="10" title="Modificaciones">
            LA PLATAFORMA podrá modificar los presentes términos en cualquier momento publicando
            la nueva versión en el sitio. El uso continuado del servicio tras la publicación
            constituye aceptación tácita de los cambios.
          </Clause>

          <Clause number="11" title="Jurisdicción">
            Para la interpretación y cumplimiento del presente contrato, las partes se someten
            expresamente a las leyes y tribunales competentes de la ciudad de Guadalajara,
            Jalisco, México, renunciando a cualquier otro fuero que pudiera corresponderles.
          </Clause>

          <div className="mt-12 pt-8 border-t border-white/10">
            <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-3">
              APODERADO LEGAL
            </div>
            <p className="font-heading font-bold text-lg">C. RICARDO ZERMEÑO MEJÍA</p>
            <p className="text-sm text-muted-foreground mt-1">
              Marketing de Inteligencia Artificial S. de R.L. de C.V.
            </p>
            <p className="text-sm text-muted-foreground">
              Av. Américas 1545, pisos 20-23, Providencia, Guadalajara, Jalisco, México
            </p>
            <p className="text-sm text-muted-foreground">
              WhatsApp de contacto: +52 33 4280 2102
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

function Clause({ number, title, children }) {
  return (
    <div data-testid={`clause-${number}`}>
      <div className="flex items-baseline gap-3 mb-2">
        <span className="font-mono text-neon-cyan text-sm">{number}.</span>
        <h3 className="font-heading font-bold text-lg leading-tight">{title}</h3>
      </div>
      <p className="pl-6">{children}</p>
    </div>
  );
}
